import { render, staticRenderFns } from "./user-agreement.vue?vue&type=template&id=58b4708c&scoped=true"
import script from "./user-agreement.vue?vue&type=script&lang=js"
export * from "./user-agreement.vue?vue&type=script&lang=js"
import style0 from "./user-agreement.vue?vue&type=style&index=0&id=58b4708c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b4708c",
  null
  
)

export default component.exports